import { Injectable } from '@angular/core';

// service with custom event names
@Injectable()
export class EventsService {
  public header: any = {
    change: 'header.change',
  };
  public notified: any = {};
  public requested: any = {};
  public received: any = {};
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/services/events.service.ts